import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  Label,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import {
  AvForm,
  AvField
} from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import showNotification from "../../helpers/show_notification";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { postSubmitForm } from "../../helpers/forms_helper";
import preloader from "../../helpers/preloader";
import { mapUnits } from "../../helpers/units";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";

const BranchItems = (props) => {

  const [openingModal, setOpeningModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  const { SearchBar } = Search;
  const refForForm = useRef(null);
  useEffect(() => {
    loadAllStores();
  }, []);
  const refContainer = useRef(null);

  const [allBrancheStores, setAllBranchStores] = useState([]);
  const [allSubStores, setAllSubStores] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState();
  const loadAllStores = async (e, v) => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res1 = response.data.filter((store) => store.type === "Branch" || store.type === "CENTRAL KITCHEN STORE")
      const res2 = response.data.filter((store) => store.type === "Sub Store")
      setAllBranchStores(res1);
      res2.forEach((store)=>{
        return (
          store.label=store.name,
          store.value=store._id
          )})
      setAllSubStores(res2);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [confirmClose, setConfirmClose] = useState(false);
  const [branchItems, setBranchItems] = useState([]);
  const loadBranchItems = async (branch_id) => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "branchitems/get_mapping";
    let response = await postSubmitForm(url, { branch_id: branch_id });
    if (response.status === 1) {
      let filtered = response.data?.filter((d)=>d.is_active) || [];
      setBranchItems(filtered);
      preloader(false);
    } else {
      showNotification(response.message, "Error");
      preloader(false);
    }
  };

  const applyLocalMappingUpdate = (item, type, store) => {
    setBranchItems((prev) =>
      prev.map((row) => {
        if (String(row.item_id) !== String(item.item_id)) return row;
        if (type === "add") {
          return { ...row, is_selected: true };
        }
        if (type === "edit") {
          const next = {
            ...row,
            is_selected: true,
            threshold: item.threshold,
            max_order_limit: item.max_order_limit,
            max_order_limit_weekly: item.max_order_limit_weekly,
          };
          if (store) {
            next.sub_store = store.label || store.name || row.sub_store;
            next.sub_store_id = store.value || store._id || row.sub_store_id;
          }
          return next;
        }
        if (type === "delete") {
          return {
            ...row,
            is_selected: false,
            is_po_allowed: false,
            direct_po: false,
            sub_store: null,
            sub_store_id: null,
          };
        }
        if (type === "remove_substore") {
          return { ...row, sub_store: null, sub_store_id: null };
        }
        return row;
      })
    );
  };

  const handleItemAction = async (item, type) => {
    const store_id = selectedStore?.value || selectedStore?._id || item.sub_store_id;

    const data_to_send = {
      branch_id: selectedBranch.branch_id,
      sub_store_id: store_id,
      branch_name: selectedBranch.branch_name,
      item_id: item.item_id,
      threshold: item.threshold,
      max_order_limit: item.max_order_limit,
      max_order_limit_weekly: item.max_order_limit_weekly,
      action: type,
    };

    let url = process.env.REACT_APP_BASEURL + "branchitems/set_mapping";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      applyLocalMappingUpdate(item, type, selectedStore);
      setEditSubStoreModal(false);
      setSelectedStore();
      setSelectedRow();
      if (type === "add") showToast(props.t(response.message));
      if (type === "edit") showToast(props.t("Branch item updated."));
      if (type === "delete") showToast(props.t("Branch item deleted."));
      if (type === "remove_substore") showToast(props.t("Sub Store unlinked successfully."));
    } else {
      showNotification(response.message, "Error");
    }
  };

  
  function showPoPermission(cell, row) {
    if (row.is_selected) {
      return (
        <>
          <div className="custom-control custom-switch mb-2" dir="ltr">
            <input
              type="checkbox"
              title="Click to change status."
              className="custom-control-input"
              id={"customSwitch1" + row._id}
              checked={row.is_po_allowed}
            />
            <label
              title="Click to change status."
              className="custom-control-label"
              htmlFor={"customSwitch1" + row._id}
              style={{ "font-weight": "100", cursor: "pointer" }}
              onClick={() => {
                handlePOPermission(row);
              }}
            ></label>
          </div>

          {row.is_po_allowed ? (
            <span class="font-size-12 badge-soft-success badge badge-success badge-pill">
              Yes
            </span>
          ) : (
            <span class="font-size-12 badge-soft-danger badge badge-danger badge-pill">
              No
            </span>
          )}
        </>
      );
    }
    // else {
    //   return (
    //     <span class="font-size-12 badge-soft-danger badge badge-danger badge-pill">
    //       No
    //     </span>
    //   );
    // }
  }
  function showDirectPoPermission(cell, row) {
    if (row.is_selected) {
      return (
        <>
          <div className="custom-control custom-switch mb-2" dir="ltr">
            <input
              type="checkbox"
              title="Click to change status."
              className="custom-control-input"
              id={"customSwitchDirectPo" + row.item_id}
              checked={row.direct_po}
              onChange={() => handleDirectPOPermission(row)}
            />
            <label
              title="Click to change status."
              className="custom-control-label"
              htmlFor={"customSwitchDirectPo" + row.item_id}
              style={{ fontWeight: "100", cursor: "pointer" }}
            ></label>
          </div>
  
          {row.direct_po ? (
            <span className="font-size-12 badge-soft-success badge badge-success badge-pill">
              Yes
            </span>
          ) : (
            <span className="font-size-12 badge-soft-danger badge badge-danger badge-pill">
              No
            </span>
          )}
        </>
      );
    }
    return null;
  }
  const [subStoreModal, setSubStoreModal] = useState(false)
  const [editSubStoreModal, setEditSubStoreModal] = useState(false)
  const [selectedStore, setSelectedStore] = useState()

  function selectStoreFormatter(cell, row) {
    if (row.sub_store !=="" && row.sub_store !== undefined && row.sub_store !== null) {
      return (
        <>
        {/* {row.sub_store}&nbsp; &nbsp; */}
          <div className="container d-flex justify-content-between">
          <div>{row.sub_store && row.sub_store}</div>
          <div>
          <span className="text-info">
                <i
                  className="bx bxs-edit font-size-15"
                  title="Click to Edit"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedRow(row);
                    setSelectedStore({label:row.sub_store,value:row.sub_store_id})
                    setEditSubStoreModal(!editSubStoreModal)
                  }}
                ></i>
              </span>
              <span className="text-danger">
                <i
                  className="bx bxs-trash font-size-15"
                  title="Click to Delete"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setConfirmClose(true)
                    setSelectedRow(row)
                  }}
                ></i>
              </span>
          </div>
          </div>
        </>
      ); 
    }else{
      return (
      <>
      {row.is_selected && (
        <span className="text-info" style={{ fontSize: "25px", color: "blue", fontWeight: "bold" }} >
        <i className="bx bx-plus"
          onClick={() => {
            setSelectedRow(row);
            setSubStoreModal(!subStoreModal)
          }}
        />
        </span>
      )}
      </>
      )
    }
  }

  const handleSelectStore = (data, changedValue) => {
    // select logic 
    if (changedValue.action === "select-option") {
     
      setSelectedStore(data);
    }
    if (changedValue.action === 'remove-value') {
      let UpdatedSelectedItem = selectedStore?.filter(item => item.label !== changedValue.removedValue.label);
      setSelectedStore(UpdatedSelectedItem);
    }

  }


  const columns = [
    {
      dataField: "item_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      csvExport: false,
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Formula"),
      dataField: "unit_levels",
      formatter:(cell,row)=>{
        return mapUnits(row.unit_levels)
      },
      sort: true,
      csvFormatter: (cell, row) => {
        if (row.unit_levels.length > 1) {
          return row.unit_levels.slice(1).map((unit, ind) => {
            const prevUnit = row.unit_levels[ind]?.unit;
            return `1 ${prevUnit} = ${unit.value} ${unit.unit}`;
          }).join('; ');
        } else {
          return row.unit_levels.map(unit => unit.unit).join(', ');
        }
      },
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "is_premium_item",
      text: props.t("Premium Item"),
      sort: true,
      editable: false,
      formatter: (cel, row) => {
        return row.is_premium_item ? "Yes" : "No";
      },
      csvFormatter: (cell, row) => {
          return row.is_premium_item?"Yes" : "No";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "threshold",
      text: props.t("Threshold"),
      sort: true,
      formatter: (cell, row) => {
        if (
          row.threshold !== undefined &&
          row.threshold !== null &&
          row.threshold !== ""
        ) {
          return row.threshold + " " + row.unit_for_threshold;
        } else {
          return "";
        }
      },
      csvFormatter: (cell, row) => {
          return row.threshold+" "+row.unit_for_threshold;
      },
      editable: true,
      type: "number",
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: 'value should be numeric'
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: 'Value should greater than 0'
          };
        }
        return true;
      },
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer" },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "sub_store",
      text: props.t("Sub Store"),
      sort: true,
      editable: false,
      align: (cell, row, rowIndex, colIndex) => {
        return "center";
      },
      style: { cursor: "pointer" },
      formatter: selectStoreFormatter,
      csvFormatter: (cell, row) => {
       return row.sub_store ? row.sub_store :""
    },
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      dataField: "max_order_limit",
      text: props.t("Max Order Limit"),
      sort: true,
      formatter: (cell, row) => {
        if (
          row.max_order_limit !== undefined &&
          row.max_order_limit !== null &&
          row.max_order_limit !== ""
        ) {
          return row.max_order_limit + " " + row.unit_for_max_order;
        } else {
          return "";
        }
      },
      editable: true,
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: 'value should be numeric'
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: 'Value should greater than 0'
          };
        }
        return true;
      },
      csvFormatter: (cell, row) => {
        return row.max_order_limit+" "+row.unit_for_max_order;
      },
      type: "number",
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer" },
      align: (cell, row, rowIndex, colIndex) => {
        return "center";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "max_order_limit_weekly",
      text: props.t("Weekly Order Limit"),
      sort: true,
      formatter: (cell, row) => {
        if (
          row.max_order_limit_weekly !== undefined &&
          row.max_order_limit_weekly !== null &&
          row.is_premium_item 
        ) {
          return row.max_order_limit_weekly + " " + row.unit_for_max_order;
        } else {
          return "";
        }
      },
      csvFormatter: (cell, row) => {
        return  row.is_premium_item ? row.max_order_limit_weekly+" "+row.unit_for_max_order: " ";
      },
      editable:(cell,row)=>{
        return row.is_premium_item ? true : false;
      } ,
      type: "number",
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer" },
      align: (cell, row, rowIndex, colIndex) => {
        return "center";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      csvExport:true
    },
    {
      text: props.t("From Supplier"),
      formatter: showDirectPoPermission,
      dataField:"direct_po",
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      csvFormatter: (cell, row) => {
        return row.direct_po?"Yes":"No";
      },
      csvExport: true,
    },
    {
      text: props.t("PO Allowed"),
      formatter: showPoPermission,
      dataField:"is_po_allowed",
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      csvFormatter: (cell, row) => {
        return row.is_po_allowed?"Yes":"No";
      },
      csvExport: true,
    },

    {
      text: props.t("Action"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      editable: false,
      formatter: (cell, row) => {
        if (row.is_selected) {
          return (
            <>
              <button
                class="btn btn-secondary btn-sm btn btn-primary mr-2"
                onClick={() => {
                  handleItemAction(row, "edit");
                }}
              >
                {props.t("Update")}
              </button>
              <button
                class="btn btn-danger btn-sm btn btn-primary"
                onClick={() => {
                  handleItemAction(row, "delete");
                }}
              >
                {props.t("Delete")}
              </button>
            </>
          );
        } else {
          return (
            <button
              class="btn btn-primary btn-sm btn btn-primary"
              onClick={() => {
                handleItemAction(row, "add");
              }}
            >
              {props.t("Add")}
            </button>
          );
        }
      },
      csvExport: false,
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const MyExportCSV = (props) => {
    const handleClick = () => {
      const fileName = `Branch_Items.csv`;
      const selectedItems = branchItems.filter((r) => r.is_selected);
      // passing my custom data
      props.onExport(selectedItems, fileName);
    };
    return (
      <div>
        <button className="btn btn-success" onClick={handleClick}>
          Export Selected to CSV
        </button>
      </div>
    );
  };

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.is_unsaved) {
      style.backgroundColor = "#ffcc00";
    } else if (row.is_selected) {
      style.backgroundColor = "#c7dced";
    } else {
      style.backgroundColor = "#dadada";
    }

    return style;
  };
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    sizePerPage: 50,
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "Next page",
    prePageTitle: "Previous page",
    firstPageTitle: "First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
  };
  const handlePOPermission = async (item) => {
    const data_to_send = {
      branch_id: selectedBranch.branch_id,
      item_id: item.item_id,
      is_po_allowed: !item.is_po_allowed,
    };
    let url = process.env.REACT_APP_BASEURL + "branchitems/set_po_permission";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      setBranchItems((prev) =>
        prev.map((row) =>
          String(row.item_id) === String(item.item_id)
            ? { ...row, is_po_allowed: !item.is_po_allowed }
            : row
        )
      );
      showToast(props.t("PO permission updated."));
    } else {
      showNotification(response.message, "Error");
    }
  };
  const handleDirectPOPermission = async (item) => {
    const data_to_send = {
      branch_id: selectedBranch.branch_id,
      item_id: item.item_id,
      direct_po: !item.direct_po,
    };
    // console.log(data_to_send); 
    let url = process.env.REACT_APP_BASEURL + "branchitems/set_direct_po";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      setBranchItems((prev) =>
        prev.map((row) =>
          String(row.item_id) === String(item.item_id)
            ? { ...row, direct_po: !item.direct_po }
            : row
        )
      );
      showToast(props.t("Direct PO permission updated."));
    } else {
      showNotification(response.message, "Error");
    }
  };
  const showToast = (message_to_show) => {
    var ele = document.getElementsByName("toastType");
    var position = document.getElementsByName("positions");
    var toastType = "info";
    var title = "";
    var message = message_to_show;

    //Close Button
    var closeButton = true;

    //Progressbar
    var progressBar = true;

    //Duplicates
    var preventDuplicates = false;

    //Newest on Top
    var newestOnTop = true;

    //position class
    var positionClass = "toast-bottom-right";

    //show duration
    var showDuration = 200;

    //Hide duration
    var hideDuration = 1000;

    //timeout
    var timeOut = 2000;

    //extended timeout
    var extendedTimeOut = 1000;

    toastr.options = {
      positionClass: positionClass,
      timeOut: timeOut,
      extendedTimeOut: extendedTimeOut,
      closeButton: closeButton,
      progressBar: progressBar,
      preventDuplicates: preventDuplicates,
      newestOnTop: newestOnTop,
      showDuration: showDuration,
      hideDuration: hideDuration,
    };

    // setTimeout(() => toastr.success(`Settings updated `), 300)
    //Toaster Types
    if (toastType === "info") toastr.info(message, title);
    else if (toastType === "warning") toastr.warning(message, title);
    else if (toastType === "error") toastr.error(message, title);
    else toastr.success(message, title);
  };

  const handleValidOpening = async (e, v) => {
    const data_to_send = {
      branch_id: selectedBranch.branch_id,
      item_id: selectedRow.item_id,
      quantity: { in_unit: v.in_unit, in_sub_unit: v.in_sub_unit },
    };
    // console.log(data_to_send);
    let url = process.env.REACT_APP_BASEURL + "branchiteminventories/opening";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      setOpeningModal(!openingModal);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleSubmitSelectedStore = async () =>{
    const data_to_send = {
      branch_id: selectedBranch.branch_id,
      sub_store_id: selectedStore._id || selectedStore.value,
      branch_name: selectedBranch.branch_name,
      item_id: selectedRow.item_id,
      threshold: selectedRow.threshold,
      max_order_limit: selectedRow.max_order_limit,
      max_order_limit_weekly: selectedRow.max_order_limit_weekly,
      action: "edit",
    };

    let url = process.env.REACT_APP_BASEURL + "branchitems/set_mapping";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      applyLocalMappingUpdate(selectedRow, "edit", selectedStore);
      setSubStoreModal(false)
      setSelectedRow()
      setSelectedStore()
      showToast(props.t(response.message));
    } else {
      showNotification(response.message, "Error");
    }
  }
  const handleUpdateSelectedStore = () =>{
    handleItemAction(selectedRow, "edit" )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Store")}
            breadcrumbItem={props.t("Branch Items - Sub Store")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                    <CardTitle>{props.t("Branch Items - Sub Store")}</CardTitle>
                  <AvForm ref={refForForm}>
                    <CardSubtitle className="mb-3">
                      {props.t(
                        "Select a branch-sub store to add/update/delete a branch item"
                      )}
                    </CardSubtitle>
                    <Row>
                      <Col lg={5}>
                        <AvField
                          name="branch"
                          // label={props.t("Select Branch")}
                          type="select"
                          validate={{ required: { value: true } }}
                          errorMessage={props.t("Branch cannot be empty")}
                          onChange={(e) => {
                            const selectedIndex =
                              e.target.options.selectedIndex;

                            setSelectedBranch({
                              branch_id: e.target.value,
                              branch_name:
                                e.target.options[selectedIndex].getAttribute(
                                  "name"
                                ),
                            });
                            loadBranchItems(e.target.value);
                          }}
                        >
                          <option value="">
                            {props.t("-- Select Branch --")}
                          </option>
                          {allBrancheStores &&
                            allBrancheStores.map((e) => (
                              <option key={e._id} value={e._id} name={e.name}>
                                {e.name}
                              </option>
                            ))}
                        </AvField>
                      </Col>
                       {/* <Col lg={7} className="text-right">
                                             
                                              <Link to="/items/map_to_all" className="btn btn-md btn-success mt-4">
            <span>{props.t("Map/Unmap to all")}</span>
          </Link>
                                            </Col> */}
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Branch Items - Sub Store")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all branch items for selected branch - Sub Store here")}
                  </CardSubtitle>
                  <ToolkitProvider
                    bootstrap4
                    keyField="item_id"
                    data={branchItems && branchItems}
                    columns={columns}
                    search
                    exportCSV={ {
                      fileName: 'branch_items.csv',
                    }}
                  >
                    {(propst) => (
                      <div>
                        <Row>
                          <Col lg={4}>
                            <SearchBar
                              {...propst.searchProps}
                              style={{ width: "300px" }}
                            />
                          </Col>
                          <Col lg={4}>&nbsp;</Col>
                          <Col lg={4} className="text-right">
                            <MyExportCSV {...propst.csvProps} />
                          </Col>
                        </Row>
                        <BootstrapTable
                          bootstrap4
                          {...propst.baseProps}
                          pagination={paginationFactory(pagination_options)}
                          noDataIndication={props.t("No data to display.")}
                          striped
                          hover
                          condensed
                          rowStyle={rowStyle}
                          cellEdit={cellEditFactory({
                            mode: "click",
                            blurToSave: true,
                            afterSaveCell: (
                              oldValue,
                              newValue,
                              row,
                              column
                            ) => {
                              if (column.dataField === "is_po_allowed") {
                                if (newValue !== oldValue)
                                  handlePOPermission(row, newValue);
                              }
                              if (column.dataField === "direct_po") {
                                if (newValue !== oldValue)
                                 handleDirectPOPermission(row, newValue);
                              }
                            },
                          })}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            size="sm"
            isOpen={openingModal}
            toggle={() => setOpeningModal(!openingModal)}
          >
            <ModalHeader toggle={() => setOpeningModal(!openingModal)}>
              {props.t("Update Opening Balance")}
            </ModalHeader>
            <ModalBody>
              {selectedRow && (
                <>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <CardBody>
                          <AvForm onValidSubmit={handleValidOpening}>
                            <Row>
                              <Col lg={12}>
                                <AvField
                                  name="in_unit"
                                  label={
                                    props.t("In Unit (") +
                                    selectedRow.unit +
                                    ")"
                                  }
                                  value="0"
                                  step="1"
                                  min="0"
                                  type="number"
                                />
                              </Col>
                              <Col lg={12} hidden={!selectedRow.sub_unit}>
                                <AvField
                                  name="in_sub_unit"
                                  label={
                                    props.t("In Sub Unit (") +
                                    selectedRow.sub_unit +
                                    ")"
                                  }
                                  min="0"
                                  max={
                                    selectedRow.formula &&
                                    Number(selectedRow.formula) - 1
                                  }
                                  step="1"
                                  value="0"
                                  type="number"
                                />
                                <span>
                                  <strong>Formula :</strong> 1{" "}
                                  {selectedRow.unit} ={" "}
                                  {selectedRow.sub_unit && selectedRow.formula}{" "}
                                  {selectedRow.sub_unit && selectedRow.sub_unit}
                                </span>
                              </Col>

                              <Col lg={12}>
                                <FormGroup className="mb-0 text-center">
                                  <Button
                                    type="submit"
                                    color="primary"
                                    className="mr-1"
                                  >
                                    {props.t("Update")}
                                  </Button>
                                </FormGroup>
                              </Col>
                            </Row>
                          </AvForm>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
          </Modal>

          {/* Sub Store Modal  */}
          <Modal
            size="md"
            isOpen={subStoreModal}
            toggle={() => setSubStoreModal(!subStoreModal)}
            onClosed={()=>setSelectedStore()}
          >
            <ModalHeader toggle={() => setSubStoreModal(!subStoreModal)}>
              {props.t("Select Sub Store")}
            </ModalHeader>
            <ModalBody>
              <AvForm onValidSubmit={handleSubmitSelectedStore}>
                <Row>

                  <Col lg={12}>
                    <Label>
                      {props.t("Sub Store")}
                    </Label>
                    <Select
                      options={allSubStores}
                      value={selectedStore}
                      onChange={(data, changedValue) => handleSelectStore(data, changedValue)}
                      closeMenuOnSelect={true}
                      classNamePrefix="select"
                      isMulti={false}
                      // className="basic-multi-select"
                    />
                  </Col>

                </Row>
                <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  </Col>
              </AvForm>
            </ModalBody>
          </Modal>

           {/* Sub Store Edit Modal  */}
           <Modal
            size="md"
            isOpen={editSubStoreModal}
            toggle={() => setEditSubStoreModal(!editSubStoreModal)}
            onClosed={()=>setSelectedStore()}
          >
            <ModalHeader toggle={() => setEditSubStoreModal(!editSubStoreModal)}>
              {props.t("Update Sub Store")}
            </ModalHeader>
            <ModalBody>
              <AvForm onValidSubmit={handleUpdateSelectedStore}>
               {selectedRow&&(
                 <Row>

                 <Col lg={12}>
                   <Label>
                     {props.t("Sub Store")}
                   </Label>
                   <Select
                     options={allSubStores}
                     value={selectedStore && selectedStore}
            onChange={(data, changedValue) => handleSelectStore(data, changedValue)}
                     closeMenuOnSelect={true}
                     classNamePrefix="select"
                     isMulti={false}
                     // className="basic-multi-select"
                   />
                 </Col>

               </Row>
               )}
                <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Update")}
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  </Col>
              </AvForm>
            </ModalBody>
          </Modal>

          {confirmClose && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmClose(false);
                        handleItemAction(selectedRow, "remove_substore");
                      }}
                      onCancel={() => {
                        setConfirmClose(false);
                        setSelectedRow()
                      }}
                    >
                      {props.t(
                        "Once you unlink sub store, it cannot be revoked."
                      )}
                    </SweetAlert>
                  )}
        </Container>
      </div>
    </React.Fragment>
  );
};
export default withRouter(connect(null, {})(withNamespaces()(BranchItems)));
